const aboutSliderSections = document.querySelectorAll( "#about" );
aboutSliderSections.forEach( ( section, i ) => {
  const aboutSlider = tns( {
    container: section.querySelector( ".slider" ),
    autoplay: false,
    controls: true,
    nav: false,
    loop: false,
    autoplayButtonOutput: false,
    controlsContainer: section.querySelector( ".slider-controls" ),
    speed: 500,
    gutter: 12,
    // fixedWidth: 202,
    items: 1.25,
    responsive: {
      768: {
        items: 2.5,
        // fixedWidth: 282,
        gutter: 24,
      },
      1024: {
        items: 4.5,
        gutter: 24,
      },
    },
  } );
} );
